import { render, staticRenderFns } from "./contact-widget.vue?vue&type=template&id=50406be4"
import script from "./contact-widget.vue?vue&type=script&lang=ts"
export * from "./contact-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports